import Layout from './Layout';

// 허브 탭 안에 들어가는 화면은 Layout 을 한 번만 — embedded 면 내용만 렌더 (Devices 허브 등)
function MaybeLayout({ embedded, children, ...layoutProps }) {
  if (embedded) return <>{children}</>;
  return <Layout {...layoutProps}>{children}</Layout>;
}

export default MaybeLayout;
